export const sizes = {
   Medium: {
      borderRadius: 'rounded-6px',
      marginRight: 'mr-12px',
      icon: {
         height: 20,
         width: 20
      }
   },
   Small: {
      borderRadius: 'rounded-4px',
      marginRight: 'mr-8px',
      icon: {
         height: 16,
         width: 16
      }
   }
}
